import { testimonials } from '@/mocks/home';

export default function TestimonialSection() {
  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-accent-100 rounded-full px-4 py-1.5 mb-4">
            <div className="w-3 h-3 rounded-full bg-accent-500"></div>
            <span className="text-xs font-medium text-accent-600 uppercase tracking-wider">读者口碑</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-black text-foreground-950 leading-tight">
            韩漫爱好者都在看
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          <div className="bg-background-50 rounded-2xl p-6 md:p-7 flex flex-col">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20portrait%20photography%20of%20a%20young%20Chinese%20woman%20with%20warm%20smile%2C%20soft%20natural%20lighting%2C%20clean%20beige%20background%2C%20casual%20style%2C%20editorial%20portrait%2C%20friendly%20approachable%20expression%2C%20warm%20skin%20tones%2C%20high%20quality%20photo&width=120&height=120&seq=avatar-01&orientation=squarish"
                alt={testimonials[0].name}
                className="w-11 h-11 rounded-full object-cover"
                loading="lazy"
              />
              <div>
                <p className="text-sm font-semibold text-foreground-900">{testimonials[0].name}</p>
                <p className="text-xs text-foreground-500">{testimonials[0].role}</p>
              </div>
            </div>
            <div className="flex-1">
              <i className="ri-double-quotes-l text-3xl text-primary-200 block mb-3"></i>
              <p className="text-sm text-foreground-700 leading-relaxed">{testimonials[0].text}</p>
            </div>
          </div>

          <div className="bg-background-50 rounded-2xl p-6 md:p-7 flex flex-col">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20portrait%20photography%20of%20a%20young%20Chinese%20man%20with%20gentle%20expression%2C%20soft%20studio%20lighting%2C%20clean%20light%20grey%20background%2C%20modern%20casual%20style%2C%20editorial%20portrait%2C%20natural%20confident%20look%2C%20warm%20tones%2C%20high%20quality%20photo&width=120&height=120&seq=avatar-02&orientation=squarish"
                alt={testimonials[1].name}
                className="w-11 h-11 rounded-full object-cover"
                loading="lazy"
              />
              <div>
                <p className="text-sm font-semibold text-foreground-900">{testimonials[1].name}</p>
                <p className="text-xs text-foreground-500">{testimonials[1].role}</p>
              </div>
            </div>
            <div className="flex-1">
              <i className="ri-double-quotes-l text-3xl text-primary-200 block mb-3"></i>
              <p className="text-sm text-foreground-700 leading-relaxed">{testimonials[1].text}</p>
            </div>
          </div>

          <div className="relative rounded-2xl overflow-hidden min-h-[280px]">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20atmospheric%20portrait%20of%20a%20young%20Asian%20woman%20reading%20a%20digital%20tablet%20with%20focused%20expression%2C%20cozy%20cafe%20interior%20background%20with%20soft%20bokeh%20lights%2C%20warm%20amber%20and%20golden%20tones%2C%20lifestyle%20photography%2C%20editorial%20mood%2C%20gentle%20warm%20lighting%2C%20shallow%20depth%20of%20field%2C%20high%20quality%20photo%2C%20artistic%20composition&width=800&height=600&seq=testimonial-bg-01&orientation=portrait"
              alt={testimonials[2].name}
              className="absolute inset-0 w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
              <p className="text-sm font-semibold text-white">{testimonials[2].name}</p>
              <p className="text-xs text-white/70">{testimonials[2].role}</p>
            </div>
          </div>

          <div className="md:col-span-2 relative rounded-2xl overflow-hidden min-h-[280px]">
            <img
              src="https://readdy.ai/api/search-image?query=Cozy%20reading%20nook%20with%20warm%20ambient%20lighting%2C%20a%20person%20comfortably%20seated%20with%20a%20tablet%20showing%20colorful%20comic%20art%2C%20bookshelf%20background%20with%20manga%20volumes%2C%20soft%20golden%20hour%20light%20through%20window%2C%20warm%20interior%20design%2C%20lifestyle%20editorial%20photography%2C%20relaxed%20atmosphere%2C%20inviting%20mood%2C%20warm%20tones%2C%20high%20detail&width=1200&height=600&seq=testimonial-wide-01&orientation=landscape"
              alt={testimonials[3].name}
              className="absolute inset-0 w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/30 to-transparent"></div>
            <div className="absolute bottom-0 left-0 p-6 md:p-8 max-w-md">
              <p className="text-base font-semibold text-white mb-1">{testimonials[3].name}</p>
              <p className="text-sm text-white/70 mb-3">{testimonials[3].role}</p>
              <p className="text-sm text-white/90 leading-relaxed">{testimonials[3].text}</p>
            </div>
          </div>

          <div className="flex flex-col gap-5">
            <div className="bg-background-50 rounded-2xl p-6 md:p-7 flex-1 flex flex-col">
              <i className="ri-double-quotes-l text-3xl text-primary-200 block mb-3"></i>
              <p className="text-sm text-foreground-700 leading-relaxed flex-1 mb-4">{testimonials[4].text}</p>
              <div className="flex items-center gap-3">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20portrait%20photography%20of%20a%20young%20Chinese%20woman%20with%20sweet%20smile%20and%20long%20dark%20hair%2C%20soft%20natural%20window%20lighting%2C%20clean%20minimalist%20white%20background%2C%20casual%20cozy%20style%2C%20editorial%20portrait%2C%20gentle%20warm%20expression%2C%20natural%20skin%20tones%2C%20high%20quality%20photo&width=120&height=120&seq=avatar-05&orientation=squarish"
                  alt={testimonials[4].name}
                  className="w-10 h-10 rounded-full object-cover"
                  loading="lazy"
                />
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{testimonials[4].name}</p>
                  <p className="text-xs text-foreground-500">{testimonials[4].role}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}